import React, { useState, useEffect } from 'react';
import { TextField } from '@fluentui/react';
import { Color } from '../../const/Const';
import { MessageConst, MessageConstEn } from '../../const/MessageConst';

const FieldPassword = (props) => {

    const [value, setValue] = useState();

    const onChanged = (p_value) => {
        setValue(p_value.target.value);
        props.onChanged(p_value.target.value, '', props.keyfield, '', props.title);
    }

    useEffect(() => {
        setValue(props.defaultValue);
    }, [props.defaultValue])

    let vColor = { fontWeight: 600 };
    if (props.gray) {
        vColor = {
            color: Color.graySecond,
            fontWeight: 400
        };
    }

    let styles = {};
    if (props.height) {
        styles = {
            field: {
                height: props.height
            },
            fieldGroup: {
                height: props.height
            }
        }
    }

    return (
        <div>
            <div style={{ display: 'flex' }}>
                <div style={{ fontSize: 14, ...vColor }}>{props.title}</div>{props.required && (<div style={{ color: Color.red }}>*</div>)}
            </div>
            <div style={{ marginTop: 6 }}>
                <TextField 
                    styles={{ ...styles }} 
                    autoComplete='off' 
                    type='password' 
                    disabled={props.disable == true ? true : false} 
                    onChange={onChanged} 
                    value={value} 
                    errorMessage={(props.required && !value && props.checkreq) ? (props.title + (props.lang == "en" ? MessageConstEn.fieldRequired : MessageConst.fieldRequired)) : null} 
                    placeholder={props.placeholder}
                    />
            </div>
        </div >
    );
}

export default FieldPassword;